import UserWithoutSubscription from './UserWithoutSubscription';

export default UserWithoutSubscription;
